import { Controller } from "@hotwired/stimulus"

// Submits the fail-open retry form (this element) after the interval. The server
// re-renders the waiting state until the failed write lands, so the loop continues.
export default class extends Controller {
  static values = {
    interval: Number
  }

  connect() {
    this.timer = setTimeout(() => this.retry(), this.intervalValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  retry() {
    this.element.requestSubmit()
  }
}
